import { Outlet, createFileRoute, redirect } from '@tanstack/react-router'
import { listProposals } from '@/api/proposals/proposals'

export function requireProposalAgent(enabled: boolean, params: { orgSlug: string; projectId: string }) {
  if (!enabled) {
    throw redirect({
      to: '/$orgSlug/$projectId/content/text',
      params: { orgSlug: params.orgSlug, projectId: params.projectId }
    })
  }
}

export const Route = createFileRoute('/_auth/$orgSlug/$projectId/proposal-agent')({
  beforeLoad: ({ context, params }) => {
    const enabled = context.user.userOrgProfile?.enabled_features.proposal_agent ?? false
    requireProposalAgent(enabled, params)
  },
  loader: async ({ params }) => {
    const projectId = parseInt(params.projectId, 10)
    const { proposals } = await listProposals(projectId)
    return { proposals }
  },
  component: ProposalAgentLayout
})

function ProposalAgentLayout() {
  // h-svh + shrink-0 (not flex-1) gives this a DEFINITE viewport height. The shared SidebarInset is
  // min-h-svh (a floor, not a definite height), so flex-1/h-full here collapse to content height and
  // the whole transcript chain grows, scrolling the page and dragging the composer with it. A
  // definite height seeds the chain so the transcript scrolls internally and the composer stays
  // pinned. overflow-hidden contains it; inner regions own their own scroll.
  return (
    <div className="flex h-svh shrink-0 flex-col overflow-hidden">
      <Outlet />
    </div>
  )
}
